// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"197":"bd5dc0039775c8e5","270":"22363610ae5d9af0","888":"1885ee35c5bc330d","976":"6bd6da000b3b47ad"}[chunkId] + ".css";
};